import React from 'react'
import SectionCard from './SectioncCard'
import cn from 'classnames'
import { Table } from '../../components/Table'
import { PrimaryButton } from '../../components'

const Stars = () => {
  const stars = Array.from({ length: 30 }, (_, i) => {
    const topValue = Math.floor(Math.random() * 65) + 5 // Random top value between 5px and 70px
    const leftValue = Math.floor(Math.random() * 90) + 5 // Random left value between 5% and 95%
    const translateOffset = Math.floor(Math.random() * 40) - 20 // Random offset between -20 and 20 for spreading
    const size = Math.random() > 0.5 ? '1px' : '2px' // Randomly choose 1px or 2px

    return (
      <div
        key={i}
        className="absolute bg-white rounded-full blur-[1px] z-5 opacity-70"
        style={{
          top: `${topValue}px`,
          left: `${leftValue}%`,
          transform: `translateX(${translateOffset}px)`,
          width: size,
          height: size
        }}
      ></div>
    )
  })
  return <>{stars}</>
}

const RepricerPossibilitiesTable = () => {
  const tableData = [
    {
      name: 'Выполнение плана продаж',
      desc: `Репрайсер управляет скоростью продаж для\u00A0выполнения плана. 
Повышает цену при\u00A0опережении плана и снижает при\u00A0отставании, чтобы достичь цели с\u00A0максимальной прибылью.`,
      ex: ['Продать 300\u00A0шт товара за месяц с максимальной прибылью.']
    },
    {
      name: 'Автоматический подбор цены',
      desc: `Репрайсер самостоятельно определяет оптимальную цену, балансируя между прибылью и количеством заказов.
      Анализирует продажи, конкурентов и другие рыночные факторы.
      `,
      ex: [
        'Найти максимальную цену без\u00A0существенного снижения продаж.',
        'Автоматически реагировать на\u00A0изменения спроса и рынка.'
      ]
    },
    {
      name: 'Разморозка продаж',
      desc: `Если товар долго не продаtтся, репрайсер автоматически снижает цену по\u00A0заданным правилам, чтобы вернуть продажи без\u00A0постоянного контроля.`,
      ex: ['Вернуть товар в активные продажи после длительного простоя']
    },
    {
      name: 'Единая цена между маркетплейсами и товарами',
      desc: `Автоматически поддерживает одинаковую цену с\u00A0учетом СПП между маркетплейсами и синхронизирует стоимость связанных товаров,
      размеров и цветов на\u00A0одном маркетплейсе`,
      ex: [
        'Поддерживать одинаковую цену на WB, Ozon и ЯМ.',
        'Синхронизировать цену всех размеров одного товара на ozon',
        'Изменять цену сразу у всей линейки товаров.'
      ]
    },
    {
      name: 'Пошаговое увеличение цены',
      desc: `Репрайсер постепенно повышает цену с\u00A0заданным шагом и интервалом, чтобы не\u00A0уронить продажи и не\u00A0пессимизировать товар в\u00A0выдаче`,
      ex: [
        'Повышать цену на 10\u00A0₽ каждые 2\u00A0дня.',
        'Найти оптимальную цену без\u00A0резкой потери заказов.',
        'Максимизировать прибыль за\u00A0счёт плавного повышения цены.'
      ]
    },
    {
      name: 'A/B-тестирование цен',
      desc: `Позволяет автоматически сравнивать эффективность разных цен и определять, какая из\u00A0них приносит больше прибыли, заказов или выручки.
      Репрайсер по\u00A0заданному расписанию меняет цену и сохраняет историю результатов для\u00A0дальнейшего анализа.`,
      ex: [
        'Проверить, какая цена приносит максимальную прибыль.',
        'Сравнить количество заказов при разных уровнях цены.',
        'Подобрать оптимальную цену для нового товара без ручных экспериментов.'
      ]
    },
    {
      name: 'Удержание цены',
      desc: `Репрайсер фиксирует точную цену или соблюдает диапазон. Можно указать,
            какую цену удерживать — с\u00A0учётом СПП, карты Ozon и WB-кошелька
            или без.`,
      ex: [
        'Соблюдение РРЦ с учётом всех скидок и карт маркетплейсов.',
        'Удержание единой цены на Ozon и Wildberries.'
      ]
    },
    {
      name: 'Конкурентное следование',
      desc: (
        <>
          <p>
            Автоматически подстраивает цену под конкурентов. Настройте
            отклонение в рублях или процентах, чтобы цена была чуть выше или
            ниже. Чтобы не торговать в убыток, задаются ограничения по цене и
            марже
          </p>
          <p className="mt-4">
            Также настраивается, какую цену конкурентов учитывать — с учетом
            карты Ozon/WB-кошелька или без.
          </p>
        </>
      ),
      ex: [
        'Ставить цену на 10 ₽ или 5% ниже конкурентов.',
        'Повышать цену, когда у конкурентов закончились остатки.'
      ]
    },
    {
      name: 'Участие в акциях',
      desc: (
        <>
          Доступные настройки для участия в акциях:
          <ul className="pl-4 list-disc list-disc-sm space-y-3 mt-3">
            <li>
              Автоматическое участие в акциях,подходящих по условиям цены и
              маржи
            </li>
            <li>
              Автоматический выход из акций при несоответствии заданным условиям
            </li>
            <li>
              Повышение цены на ночь для увеличения медианы и порога входа
            </li>
            <li>
              Ежечасный пересчёт условий входа и автоматическое повышение цены
              при их изменении
            </li>
            <li>Повышение цены сразу после завершения акции</li>
            <li>
              Установка цены, позволяющей участвовать хотя бы в одной акции с
              сохранением максимальной маржи.
            </li>
          </ul>
        </>
      ),
      ex: ['Соблюдение РРЦ с учётом всех скидок и карт маркетплейсов.']
    },
    {
      name: 'Защита от нулевого остатка',
      desc: (
        <>
          Позволяет поднять цену, когда товар почти распродан. Например, чтобы
          замедлить продажи, избежать полного отсутствия на складе и падения в
          поисковой выдаче.
        </>
      ),
      ex: [
        'Повышать цену на 30% если остаток вашего товара станет меньше 3 шт.'
      ]
    },
    {
      name: 'Оборачиваемость',
      desc: (
        <>
          <p>
            Автоматического изменения цены в зависимости от того, на сколько
            дней хватит текущих остатков.
          </p>
          <p className="mt-4">
            Настройка помогает управлять скоростью продаж: стимулировать спрос
            при избыточных остатках и замедлять продажи, увеличивая маржу, когда
            товара на складе недостаточно.
          </p>
        </>
      ),
      ex: [
        'Если товара хватает более чем на 60 дней → снизить цену на 20%, чтобы ускорить продажи',
        'Если товара хватает менее чем на 5 дней → поднять цену на 30%, чтобы замедлить продажи и избежать обнуления остатков.'
      ]
    },
    {
      name: 'Расписание',
      desc: (
        <>
          <p>Позволяет задать, в какие дни и часы должен работать репрайсер.</p>
          <p className="mt-4">
            Для одного товара можно настроить несколько стратегий с разным
            временем действия. Например, одни правила для будней, другие для
            выходных.
          </p>
          <p className="mt-4">
            Расписание можно использовать для A/B-тестов: сравнивать
            эффективность разных цен в разное время суток.
          </p>
        </>
      ),
      ex: [
        'Повышение цены ночью, чтобы увеличить порог входа в акцию.',
        'Настройка разных режимов репрайсера по дням недели и времени суток.'
      ]
    },
    {
      name: 'Журнал репрайсера',
      desc: (
        <>
          <p>
            Хранит полную историю работы репрайсера. Отображает, какие цены
            устанавливались, когда и почему.
          </p>
          <p className="mt-4">
            Позволяет отследить динамику изменений, увидеть, какие цены были у
            конкурентов на каждом этапе, и понять логику принятия решений
            системой.
          </p>
        </>
      ),
      ex: []
    },
    {
      name: 'Массовая загрузка',
      desc: (
        <>
          <p>
            Позволяет быстро создавать и редактировать настройки репрайсера для
            большого количества товаров через Excel-файл.
          </p>
          <p className="mt-4">
            Удобна при первичной настройке и для массового внесения изменений.
          </p>
        </>
      ),
      ex: []
    },

    {
      name: 'Юнит экономика',
      desc: (
        <>
          <p>
            Автоматически рассчитывает маржу по каждому товару с учётом всех
            затрат при работе на маркетплейсах — комиссии, логистики, хранения и
            других расходов.
          </p>
          <p className="mt-4">
            Позволяет определить минимальную цену без убытков, рассчитать
            максимально допустимую скидку.
          </p>
        </>
      ),
      ex: []
    },
    {
      name: 'Аналитика',
      desc: `Показывает историю изменения цен, цен конкурентов, заказов, участия в акциях и других ключевых показателей, помогая анализировать эффективность работы репрайсера и принимать обоснованные решения.`,
      ex: [
        'Посмотреть, как менялись цена товара, цены конкурентов, количество заказов и участие в акциях.',
        'Проанализировать эффективность работы репрайсера и понять, какие изменения привели к росту прибыли или продаж.'
      ]
    },
    {
      name: 'Перерасчет цен каждые 30 минут',
      desc: `Репрайсер автоматически анализирует ситуацию и пересчитывает цены каждые 30 минут, быстро реагируя на изменения рынка.`,
      ex: [
        'Мгновенно реагировать на изменение цен конкурентов.',
        'Повышать цену сразу после ухода конкурентов.',
        'Не упускать продажи при изменении спроса.'
      ]
    },
    {
      name: 'Ручное подтверждение',
      desc: (
        <>
          <p>
            Репрайсер рассчитывает цены и отображает их в журнале, но не
            отправляет на маркетплейс.
          </p>
          <p className="mt-4">
            Используйте настройку, чтобы проверить расчёты и убедиться, что они
            соответствуют заданным настройкам, прежде чем включать
            автоматическое обновление цен.
          </p>
        </>
      ),
      ex: []
    }
  ]

  const cols = {
    name: {
      renderCell: (value, i) => (
        <div className="sm:w-[280px] text-sm lg:text-[20px] font-medium">
          <div
            className={cn('text-xs text-[#919BA0] mb-2 font-normal', {
              'lg:hidden': i !== 0,
              'lg:mb-8 lg:text-[16px]': i === 0
            })}
          >
            Название
          </div>
          {value}
        </div>
      )
    },
    desc: {
      renderCell: (value, i) => (
        <div className="sm:w-[440px] leading-[22px]">
          <div
            className={cn('text-xs text-[#919BA0] mb-2 font-normal', {
              'lg:hidden': i !== 0,
              'lg:mb-8 lg:text-[16px]': i === 0
            })}
          >
            Описание
          </div>
          {value}
        </div>
      )
    },
    ex: {
      renderCell: (value, i) => (
        <div className="sm:w-[280px] text-[#CDAA75] leading-[22px]">
          {!!value.length && (
            <div
              className={cn('text-xs text-[#919BA0] mb-2 font-normal', {
                'lg:hidden': i !== 0,
                'lg:mb-8 lg:text-[16px]': i === 0
              })}
            >
              Пример использования
            </div>
          )}
          {value.length === 1 ?
            value
          : <ul className="pl-6 list-decimal space-y-3">
              {value.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          }
        </div>
      )
    }
  }

  return (
    <Table
      buttonText="Все возможности репрайсера"
      title="Возможности репрайсера"
      tableData={tableData}
      cols={cols}
      defaultOpen
    >
      <div className="flex items-center justify-center space-x-4 my-10">
        <hr className="border-t-2 border-white/20 border-dashed flex-1" />
        <span className="font-normal text-base leading-[24px] text-[#FBFBFC] text-center">
          И еще множество гибких настроек
          <br className="hidden lg:block" /> для роста маржи на каждом заказе
        </span>
        <hr className="border-t-2 border-white/20 border-dashed  flex-1" />
      </div>
    </Table>
  )
}

const RepricerSection = () => (
  <div className="max-w-[1200px] mx-auto mb-20">
    <h1 className="text-[#FBFBFC] text-4xl md:text-[60px] font-medium leading-tight mb-12 lg:text-center">
      <span className="text-[#52575D]">Репрайсер —</span>
      <br className="hidden lg:block" /> главный инструмент для роста{' '}
      <br className="hidden lg:block" />
      прибыли на маркетплейсах
    </h1>

    <div className="bg-[#1A1A2B] rounded-[20px] lg:rounded-[60px] p-10 lg:p-16  mb-12 relative overflow-hidden">
      <div className="absolute inset-0 rounded-full  blur-[80px] z-0 w-[50%] h-[120%] opacity-90 left-0 bottom-0  translate-y-1/3 bg-[#9B49CB]"></div>
      <div className="absolute inset-0 rounded-full  blur-[80px] z-0 w-[50%] h-[120%] opacity-90 right-0 bottom-0 translate-x-full translate-y-1/3 bg-[#8770ff]"></div>
      <h2 className="text-white tracking-tight text-3xl lg:text-6xl font-medium lg:text-center lg:leading-[70px] z-10 relative">
        <span>Автоматически управляет ценами,</span>{' '}
        <br className="hidden lg:block" />{' '}
        <span className="opacity-50">чтобы вы зарабатывали больше</span>
      </h2>
      <Stars />
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8 lg:text-center overflow-hidden">
      <SectionCard>
        <div className="flex flex-row lg:block justify-between">
          <h3 className="text-[#FBFBFC] text-xl  lg:text-2xl font-medium mb-4 lg:mb-10">
            Контроль РРЦ и индекса цен
          </h3>
          <span className="block lg:hidden">
            <img
              src="/assets/padlock-full.png"
              alt="Padlock icon"
              width={60}
              height={60}
            />
          </span>
        </div>

        <p className="text-[#9DA3AE] text-lg lg:mb-4">
          Репрайсер контролирует соблюдение РРЦ, поддерживает единые цены между
          площадками и обеспечивает требуемый индекс цен.
        </p>
        <div className="absolute bottom-0  transform hidden lg:block ">
          <img
            src="/assets/Padlock_perspective_matte.png"
            alt="Padlock icon"
            width={420}
            height={420}
          />
          <div className="absolute -bottom-10 left-1/2 transform -translate-x-1/2 w-[90%] h-48 bg-gradient-to-t from-yellow-400/90 via-yellow-500/50 to-transparent blur-[50px] rounded-full"></div>
        </div>
      </SectionCard>

      <div className="flex flex-col h-full">
        <SectionCard className="mb-6 flex flex-col">
          <div className="flex flex-row  justify-between lg:justify-center">
            <h3 className="text-[#FBFBFC] text-xl font-medium mb-4">
              Выполнение
              <br className="block lg:hidden" /> плана продаж
            </h3>
            <span className="block lg:hidden">
              <img
                src="/assets/graph.png"
                alt="RepricerGraphIcon"
                className="w-[100px] object-fit"
              />
            </span>
          </div>
          <p className="text-[#9DA3AE] text-base">
            Репрайсер находит максимальную цену,
            <br className="hidden lg:block" /> при которой план продаж
            продолжает выполняться.
          </p>
          <div className="mt-10 justify-center hidden lg:flex">
            <img
              src="/assets/graph.png"
              alt="RepricerGraphIcon"
              width={270}
              height={145}
            />
          </div>
        </SectionCard>

        <SectionCard>
          <h3 className="text-[#FBFBFC] text-xl font-medium mb-4 lg:text-center">
            Максимизация прибыли
          </h3>
          <p className="text-[#9DA3AE] text-base">
            Подбирает оптимальную цену,
            <br className="hidden lg:block" />
            балансируя прибыль и количество заказов
          </p>
        </SectionCard>
      </div>
    </div>

    <RepricerPossibilitiesTable />
    <div className="mt-8 flex justify-center items-center flex-col lg:flex-row">
      <PrimaryButton
        className={
          'w-full py-5 lg:w-fit lg:px-12 lg:py-6 flex items-center justify-center'
        }
        onClick={() => (window.location.href = 'https://go.priceninja.ru/auth')}
      >
        <span className="text-white font-semibold text-[18px] leading-[21px] lg:text-xl lg:leading-6">
          Попробовать бесплатно
        </span>
      </PrimaryButton>
    </div>
  </div>
)

export default RepricerSection
